




















import { Vue, Component, Prop } from "vue-property-decorator";
import SVGIcon from "@/components/SVGIcon.vue";
import LanguageSelector from "@/components/LanguageSelector.vue";
import { mapActions, mapState } from 'vuex';

@Component({
  components: {
    SVGIcon,
    LanguageSelector,
  },
  methods: {
    ...mapActions('global', ['toggleCart'])
  },
  computed: {
    ...mapState('global', ['cartOpen', 'cart'])
  }
})
export default class Header extends Vue {
  langNav = false;
  landingUrl = "https://wishope.tinaba.it";

  toggleLangNav() {
    this.langNav = !this.langNav
  }

  hideLangNav() {
    this.langNav = false
  }

  mounted() {

    const { pathname } = window.location;
    const parts = pathname ? pathname.split('/') : [];
    if(parts.length >= 4)
    {
      const merchantId = String(parts[1])
      const shopId = String(parts[3])
      const vasId = String(parts[4])

      if(shopId === '1009902') { this.landingUrl = 'https://wishope.tinaba.it/'; }
    }
  }
}
